<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [description]="workshop.description"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<p-dialog
  [(visible)]="showApprovalPromptPopup"
  [modal]="true"
  [rtl]="true"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="p-fluid"
>
  <app-registration-approval-prompt [template]="approvalTemplate">
  </app-registration-approval-prompt>
  <ng-template #approvalTemplate let-data>
    کاربر گرامی! مجوز مشاهده ویدیو کارگاه های آموزشی افرا برای شما صادر نشده
    است. برای دریافت مجوز مربوطه با مدیر عامل موسسه نیکوکاری خود
    {{ data.charityTitle }} سرکار خانم/جناب آقای
    <strong>{{ data.ceoFullName }}</strong> تماس بگیرید.
  </ng-template>
</p-dialog>
